import { cloneElement } from "react";
import { InteractionScreen } from "../../../Redux/screenInteractionsSlice";
import { Direction } from "../../DirectionalButtons/DirectionButton";
import { useAppSelector } from "../../../Redux/store";

export type ActionButton = 'x' | 'z' | 'home' | 'start'

interface IProps {
    button: Direction | ActionButton;
    screen: InteractionScreen;
    children: React.ReactElement;
}

export const ButtonActionResolver: React.FC<IProps> = ({children, button}) => {

    const { screen } = useAppSelector(s => s.screenInteractions);

    const onDown = () => {
        window.postMessage({ wowboi: true, event: 'kd', button });
    }
    const onUp = () => {
        if (screen === InteractionScreen.GAME || screen === InteractionScreen.SANDBOX) {
            window.postMessage({ wowboi: true, event: 'ku', button });
        }
    }

    return cloneElement(children, { onDown, onUp, direction: button })
}
